import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { SetupAccountService } from 'src/app/share/services/setup-account.service';

@Component({
    selector: 'app-setup-account',
    templateUrl: './setup-account.component.html',
    styleUrls: ['./setup-account.component.scss'],
    standalone: false
})
export class SetupAccountComponent implements OnInit {
  showForm3 = false;
  showForm4 = true;
  showForm5 = false;
  hide:boolean = true;
  hide1 : boolean = true;
  welRegHeader = true;
  subRegHeader = true;
  companyNamevalue: any;
  registrationTypevalue: any;
  emailAddressvalue: any;
  namevalue: any;
  secondaryPhoneNumber: any;
  ifReg = true;
  errorVerify: any;
  isLoading  : boolean= false;
  loader : boolean = false;


  constructor(
    private readonly fb: FormBuilder,
    private readonly setupAccountService: SetupAccountService
    ){
  }

  ngOnInit(): void{
        this.welRegHeader = true;
        this.subRegHeader = true;
  }

  secondaryForm: FormGroup = this.fb.group({
    phoneNumber: ['',
    [
      Validators.required,
      Validators.pattern(RegExpPatterns.MobilePattern),
    ],
  ],    
  })

  registerForm5: FormGroup = this.fb.group({
    otp: ['', [Validators.required]],
    password: ['', [Validators.required,Validators.pattern(RegExpPatterns.PasswordPattern)]],
   confirmPassword: ['', [Validators.required]],
  }, {
    validators: this.passwordsMatchValidator
  } as any);

  passwordsMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    if (password === confirmPassword) {
      formGroup.get('confirmPassword')?.setErrors(null);
    } else {
      formGroup.get('confirmPassword')?.setErrors({ passwordsMismatch: true });
    }
  }

  verifySecondaryUser(){
    this.isLoading = true;
    this.setupAccountService.secondryUserAccountSetup(this.secondaryForm.value).subscribe({
      next: (res:any)=>{
      this.isLoading = false;
      this.secondaryPhoneNumber=this.secondaryForm.controls['phoneNumber'].value
      this.showForm4 = false;
      this.showForm5 = true;
    },
      error: (error) =>{
      this.errorVerify = error?.error?.error?.message;
      this.isLoading = false;
    }
    });
  }

  resendOTP(){
    this.loader = true;
    this.setupAccountService.secondryUserAccountSetup({phoneNumber:this.secondaryPhoneNumber}).subscribe({
      next: (res:any)=>{
      this.loader = false;
    },
      error: (error) =>{
      this.errorVerify = error?.error?.error?.message;
      this.loader = false;
    }
    });
  }

  onVerify5(){
    this.isLoading = true;
    const payload= { ...this.registerForm5.value };
    delete payload.confirmPassword;
    this.setupAccountService.registerSecondryUser({...payload,phoneNumber:this.secondaryPhoneNumber}).subscribe({
      next: (res:any)=>{
      this.isLoading = false;
      this.showForm5 = false;
      this.showForm3 = true;
    },
      error: (error) =>{
      this.errorVerify = error?.error?.error?.message;
      this.isLoading = false;
    }
    })
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.secondaryForm.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  input(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 6) {
      inputElement.value = inputElement.value.slice(0, 6);
      this.registerForm5.controls['otp'].setValue(inputElement.value);
    }
  }

  protected readonly faEye = faEye;
  protected readonly faEyeSlash = faEyeSlash;
}
